<div class="search-filters-bottom-sheet">
  <!-- Header -->
  <div class="search-filters-bottom-sheet__header">
    <h2 class="search-filters-bottom-sheet__title">
      {{ 'search_results.filters.mobile_title' | translate }}
    </h2>
    <button
      class="search-filters-bottom-sheet__close-button"
      (click)="close()"
      aria-label="Close">
      <img
        src="/assets/images/icons/close-icon-mobile.svg"
        alt="Close"
        class="search-filters-bottom-sheet__close-icon"
      />
    </button>
  </div>

  <!-- Content -->
  <div class="search-filters-bottom-sheet__content">
    <!-- Filter Type Section -->
    <div class="search-filters-bottom-sheet__section">
      <div class="search-filters-bottom-sheet__section-header">
        <img src="/assets/images/icons/filter-icon.svg" alt="" class="search-filters-bottom-sheet__icon" />
        <h3 class="search-filters-bottom-sheet__section-title">{{ 'search_results.filters.title' | translate }}</h3>
      </div>
      <div class="search-filters-bottom-sheet__filter-options">
        <label class="filter-option" for="filter-everything">
          <input
            id="filter-everything"
            type="radio"
            name="filterType"
            value="everything"
            [checked]="activeFilterType === 'everything'"
            (change)="onFilterTypeChange('everything')"
            class="filter-option__input" />
          <span class="filter-option__label">{{ 'search_results.filters.everything' | translate }}</span>
        </label>
        <label class="filter-option" for="filter-project">
          <input
            id="filter-project"
            type="radio"
            name="filterType"
            value="project"
            [checked]="activeFilterType === 'project'"
            (change)="onFilterTypeChange('project')"
            class="filter-option__input" />
          <span class="filter-option__label">{{ 'search_results.filters.project' | translate }}</span>
        </label>
        <label class="filter-option" for="filter-organization">
          <input
            id="filter-organization"
            type="radio"
            name="filterType"
            value="organization"
            [checked]="activeFilterType === 'organization'"
            (change)="onFilterTypeChange('organization')"
            class="filter-option__input" />
          <span class="filter-option__label">{{ 'search_results.filters.organization' | translate }}</span>
        </label>
      </div>
    </div>
  </div>

  <!-- Footer with Apply Button -->
  <div class="search-filters-bottom-sheet__footer">
    <button class="search-filters-bottom-sheet__apply-button" (click)="applyFilters()">
      {{ 'search_results.filters.apply' | translate }}
    </button>
  </div>
</div>
